import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';

import { MaintenanceBannerViewModel } from '@mp/system/maintenance/domain';
import { MaintenanceBannerComponent } from '@mp/system/maintenance/ui';
import { buildMaintenanceBannerViewModel } from '@mp/system/maintenance/util';

import { MaintenanceLockService } from '../../services';

/**
 * Zeigt das Wartungsbanner: die Komponente liest nur die Signale des `MaintenanceLockService`, gestartet wird
 * die Überwachung von `provideMaintenanceFeature()`.
 */
@Component({
  selector: 'mps-maintenance-banner-container',
  templateUrl: './maintenance-banner-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaintenanceBannerComponent],
})
export class MaintenanceBannerContainerComponent {
  private readonly maintenanceLockService = inject(MaintenanceLockService);

  protected readonly viewModel: Signal<MaintenanceBannerViewModel | null> = computed(() =>
    buildMaintenanceBannerViewModel(
      this.maintenanceLockService.stateInfo(),
      this.maintenanceLockService.correctedNow(),
    ),
  );
}
